/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { arrayOf, entity, enumeration, subentity } from '@gh/core-data';
import {
  AveragePreconstructionBuildTimesDto,
  AveragePreconstructionBuildTimesPoint,
  AveragePreconstructionBuildTimesValue,
  DashboardChartType,
} from '../dto';

export const AveragePreconstructionBuildTimesMapper = entity<AveragePreconstructionBuildTimesDto>({
  values: arrayOf(subentity<AveragePreconstructionBuildTimesValue>({
    points: arrayOf(subentity<AveragePreconstructionBuildTimesPoint>({
      type: enumeration(DashboardChartType),
    })),
  })),
});
